var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"ctl-bar"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.getData}},[_vm._v("刷新")])],1),_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.items,"size":"small","bordered":"","loading":_vm.loading,"scroll":_vm.computedScroll,"pagination":{pageSize: 50},"rowKey":"_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }